export default __webpack_public_path__ + "static/media/Comfortaa-Regular.d2968d78.ttf";